import { alpha } from '@mui/material/styles';

export const buildDialogThemeOverrides = ({ accentColor = '#4ce1b6' } = {}) => ({
  MuiDialog: {
    styleOverrides: {
      paper: ({ theme }) => ({
        border: `1px solid ${alpha(accentColor, theme.palette.mode === 'dark' ? 0.22 : 0.18)}`,
        borderRadius: 16,
        overflow: 'hidden',
        position: 'relative',
        boxShadow:
          theme.palette.mode === 'dark'
            ? '0 30px 80px rgba(0,0,0,0.65), 0 8px 24px rgba(76,225,182,0.14)'
            : '0 26px 64px rgba(0,0,0,0.2), 0 8px 20px rgba(76,225,182,0.14)',
        '&::after': {
          content: '""',
          position: 'absolute',
          left: 0,
          right: 0,
          top: 0,
          height: 3,
          background: `linear-gradient(90deg, ${alpha(accentColor, 0.9)} 0%, ${alpha(accentColor, 0.35)} 60%, transparent 100%)`,
        },
      }),
    },
  },
  MuiDialogTitle: {
    styleOverrides: {
      root: ({ theme }) => ({
        padding: '12px 16px',
        color: theme.palette.text.primary,
        fontWeight: 600,
        background: `linear-gradient(${alpha(accentColor, 0.08)}, ${alpha(accentColor, 0.08)}), ${theme.palette.background.paper}`,
        borderBottom: `2px solid ${theme.palette.mode === 'dark' ? '#333246' : '#e0e0e0'}`,
      }),
    },
  },
  MuiDialogContent: {
    styleOverrides: {
      root: ({ theme }) => ({
        paddingTop: 14,
        paddingBottom: 12,
        backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.01)' : 'rgba(255,255,255,0.75)',
        '.MuiDialogTitle-root + &': {
          paddingTop: '10px !important',
        },
      }),
    },
  },
  MuiDialogActions: {
    styleOverrides: {
      root: ({ theme }) => ({
        padding: '10px 16px 16px',
        borderTop: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)'}`,
        backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.015)' : 'rgba(255,255,255,0.9)',
      }),
    },
  },
});

export default buildDialogThemeOverrides;
